module.exports = "/fonts/opensanssemibold.ttf";